import _ from "lodash";
import { queryWaterProviderWithDocs } from "./api";
import { PROVIDER_FIELDS, QUERY_URL_AND } from "./constants";
import { getProviders } from "./fetchProviders";
import { WaterProvider } from "./types";

export const fetchProviderByConnectionSizeCategories = async (
    connnectionSizeCategories: string[],
    returnSize: number = 1000
): Promise<WaterProvider[]> => {
    const valid = connnectionSizeCategories?.filter(d => d != null && d?.toString()?.trim() !== "");
    if (!valid?.length) return [];

    const providers = getProviders();

    if (providers?.length > 0) {
        const connnectionSizeCategoryMap = valid.reduce((prev, cur) => {
            prev[cur] = 1;
            return prev;
        }, {});

        return providers
            ?.filter(d => connnectionSizeCategoryMap[d.connectionSizeCategory] === 1)
            ?.filter((d, index) => index < returnSize);
    }

    const conSizeQuery = `(${_.join(
        valid.map(conCat => `"${conCat}"`),
        "OR"
    )})`;

    const solrQuery = _.join(
        [
            "q=*:*",
            `rows=${returnSize}`,
            `fq=pure_strings_connection_size_ct:${conSizeQuery}`,
            // "fl=pure_strings_sname,pure_strings_admin_id,its_tid,pure_strings_connection_size_ct,pure_strings_residential_tariff_struct,fts_connection_size"
            `fl=${PROVIDER_FIELDS}`
        ],
        QUERY_URL_AND
    );

    const _providers = await queryWaterProviderWithDocs(solrQuery);

    return _providers;
};
